export default __webpack_public_path__ + "bb9d7a3e328f0c39f350a7399b0338c6.png";